import KeyboardEventEnum from 'common/types/KeyboardEventEnum';
import React, { useCallback, useState } from 'react';
import SafariPinnedTab from '_design/sass/img/safari-pinned-tab.svg';
import IconDotGov from '_design/sass/img/icon-dot-gov.svg';
import IconHttps from '_design/sass/img/icon-https.svg';

const CdsHeaderTrustedSite = () => {
  const [isVisible, setVisibility] = useState(false);
  const toggleVisibilityClick = useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
    setVisibility((prev) => !prev);
  }, []);

  const toggleVisibilityKeyDown = useCallback((event: React.KeyboardEvent) => {
    if (event.key === KeyboardEventEnum.Enter || event.key === KeyboardEventEnum.Space) {
      event.stopPropagation();
      setVisibility((prev) => !prev);
    }
  }, []);

  return (
    <div className="site-trust-seal">
      <div className="trust-seal-link container">
        <div className="row">
          {/* React requires tabIndex for clickable divs
              https://developers.google.com/web/fundamentals/accessibility/focus/using-tabindex
           */}
          <div
            className="col ml-2 trust-seal-link-container"
            onClick={toggleVisibilityClick}
            role="button"
            tabIndex={0}
            onKeyDown={toggleVisibilityKeyDown}
          >
            <img src={SafariPinnedTab} className="trust-seal-flag" title="Flag" alt="Trusted Flag" />
            <div>
              <span>An official website of the City of Chicago</span>
              <button
                className={`trust-seal-action ${isVisible ? '' : 'collapsed'}`}
                title="Here’s how you know"
                type="button"
                onClick={toggleVisibilityClick}
                onKeyDown={(e) => e.stopPropagation()}
              >
                <span>Here’s how you know</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={`trust-seal-content collapse container mt-4 ${isVisible ? 'show' : ''}`}>
        <div className="row">
          <div className="col-sm-6">
            <div className="media">
              <img className="mr-3 trust-seal-icon" src={IconDotGov} alt="Generic placeholder" />
              <div className="media-body">
                <h5 className="mt-0">The .gov means it’s official.</h5>
                Municipal government websites often end in .gov or .org. Before sharing sensitive information, make sure
                you’re on a City of Chicago government site.
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="media">
              <img className="mr-3 trust-seal-icon" src={IconHttps} alt="Generic placeholder" />
              <div className="media-body">
                <h5 className="mt-0">The site is secure.</h5>
                The <strong>https://</strong> ensures that you are connecting to the official website and that any
                information you provide is encrypted and transmitted securely.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CdsHeaderTrustedSite;
